/** @format */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SmsNotification } from '@shared/data-access/interfaces';
import { SmsNotificationDao } from './sms-notification.dao';

@Injectable({
  providedIn: 'root',
})
export class SmsNotificationService {
  constructor(private readonly smsNotificationDao: SmsNotificationDao) {}

  public getOptIn(phoneNumber: string): Observable<SmsNotification> {
    return this.smsNotificationDao.getSmsOptInNotificationValue(phoneNumber.replace(/\D/g, ''));
  }

  public postOptIn(phoneNumber: string): Observable<SmsNotification> {
    return this.smsNotificationDao.setSmsOptInNotificationValue(phoneNumber.replace(/\D/g, ''));
  }
}
